import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Mixpanel from 'mixpanel-browser';
import Header from '~/components/Header';
import Button from '~/components/Button';
import { NavigationPath, ScreenProps } from '~/core/dto/navigationDTO';
import yahoo from '~/assets/images/yahoo.png';
import spotify from '~/assets/icons/Spotify.svg';
import reddit from '~/assets/icons/Reddit.svg';
import epicGames from '~/assets/icons/EpicGames.svg';
import qualia from '~/assets/images/qualia.png';

import './Intro.styles.css';
import Spacer from '~/components/Spacer';

const Intro: FC<ScreenProps> = ( { type } ) => {

  const navigate = useNavigate();
  const routeName = `Intro-${type}`;

  const onContinue = () => {

    Mixpanel.track( routeName, { state: 1 } );

    navigate( type === 'adult' ? NavigationPath.AdultQuizIntro : NavigationPath.QuizIntro );

  };

  useEffect( () => {

    Mixpanel.track( routeName, { state: 0 } );

  }, [] );

  return (
    <div className="container">
      <Header type={type} />
      <Spacer size={8} />
      <div className="scrollContainer">
        <div className="introContent containerPadding">
          <Spacer size={24} />
          <h1 className="primaryBroadbill textCenter">20K+ people</h1>
          <Spacer size={8} />
          <p className="textCenter">already use Birdwingo app</p>
          <Spacer size={24} />
          <div className="introBox flexColumn alignCenter">
            <h1 className="introQuoationMarks primaryBroadbill">”</h1>
            <h2 className="textCenter">The Birdwingo app represents a first-of-its-kind platform in the EU</h2>
            <img src={yahoo} alt="Yahoo" />
          </div>
          <Spacer size={24} />
          <h3 className="textCenter">BROUGHT TO YOU BY INVESTORS OF</h3>
          <Spacer size={18} />
          <ul className="introInvestorsList flexRow justifyCenter alignCenter">
            <li>
              <img src={spotify} alt="Spotify" />
            </li>
            <li>
              <img src={reddit} alt="Reddit" />
            </li>
            <li>
              <img src={epicGames} alt="Epic Games" />
            </li>
            <li>
              <img src={qualia} alt="Qualia" />
            </li>
          </ul>
          <Spacer size={24} />
        </div>
      </div>
      <div>
        <Spacer size={16} />
        <Button onPress={onContinue}>Continue</Button>
        <Spacer size={16} />
      </div>
    </div>
  );

};

export default Intro;
